import styled from "styled-components";
import {tokens} from "../../../../theme";

export const MetadataBox = styled.div`
    padding: 12px;
    background: ${({theme}) => theme.palette.background.element};
    border: 1px solid ${({theme}) => theme.palette.dividers.subtle};
    border-radius: ${tokens.radius.md};
    font-size: ${tokens.fontSize.xs};
    color: ${({theme}) => theme.palette.text.hint};
`;

export const MetadataRow = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 4px 0;

    &:not(:last-child) {
        border-bottom: 1px solid ${({theme}) => theme.palette.dividers.subtle};
        margin-bottom: 4px;
        padding-bottom: 8px;
    }
`;

export const MetadataLabel = styled.span`
    font-weight: ${tokens.fontWeight.medium};
`;

export const MetadataValue = styled.span`
    color: ${({theme}) => theme.palette.text.primary};
`;

export const BoxesList = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 8px;
`;

export const BoxBadge = styled.div<{ color?: string }>`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    background: ${({color, theme}) => color || theme.background.element};
    border: 1px solid ${({color, theme}) => color ? 'transparent' : theme.palette.divider};
    border-radius: ${tokens.radius.md};
    font-size: ${tokens.fontSize.xs};
    font-weight: ${tokens.fontWeight.medium};
    color: ${({theme}) => theme.palette.text.primary};
`;
